import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "This study is no longer live.", "SetupError", "Study not live.", "app.error.studynotlive")
